export enum ModelState {
  Create = 1,
  Edit = 2,
  View = 3,
}
